import { Injectable } from '@angular/core';

import { AngularFireDatabase } from '@angular/fire/database';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  public themeListRef: firebase.database.Reference;
  constructor(private db: AngularFireDatabase, private http: HttpClient) {
    this.themeListRef = db.database.ref('/com_shelcaster_theme');
   }

   getThemeList() {
     return this.themeListRef.child('themebuilder');
   }

   getBaseUrl() {
     return this.themeListRef.child('siteproperty');
   }

   getSiteProps() {
    return this.themeListRef.child('siteproperty');
  }

  getTranslations() {
    return this.themeListRef.child('translator');
  }

  getAuthorizationSettings() {
    return this.themeListRef.child('authorizationsetting');
  }

  getThemeApi() {
    return this.http.get('https://edmersonmusicgroup.com/apis/themes.php');
  }

  getSitePropsApi() {
    return this.http.get('https://edmersonmusicgroup.com/apis/site-props.php');
  }
}
